import invoiceInstance from '../instance'

const correctInvoice = (invoiceUuid, recipient) => {
	return invoiceInstance.post(`/invoices/${invoiceUuid}/corrections`, recipient)
}

export default correctInvoice
